import { render, staticRenderFns } from "./certify-detail.vue?vue&type=template&id=79d72702&scoped=true"
import script from "./certify-detail.vue?vue&type=script&lang=js"
export * from "./certify-detail.vue?vue&type=script&lang=js"
import style0 from "./certify-detail.vue?vue&type=style&index=0&id=79d72702&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d72702",
  null
  
)

export default component.exports